import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import logo from '../../logo.svg';
import UserWidget from "../user/user-widget";
import { MainMenu } from "./main-menu";
// import notificationsIcon from "../../assets/images/notifications.svg";
import Wearables from "../user/wearables";
import { useContext } from "react";
import { UserContext } from "../../App";

export default function Header() {
    const { t } = useTranslation();
    const { userProfile } = useContext(UserContext);

    const is_athlete = (userProfile.role.filter((r: any) => r.id == 'padeltech_athlete').length > 0);

    return (
        <header>
            <Container>
                <Row>
                    <Col>
                        <div className="header-content">
                            <Link className="branding" to="/" title={ t("go_home")}>
                                <img alt="PadelTech" src= {logo}/>
                            </Link>

                            <div className="user-bar">
                                <UserWidget />
                                {/* <div className="notifications">
                                    <img src={ notificationsIcon } alt={ t("notifications") }/>
                                    <div className="icon-name">{ t("notifications") }</div>
                                </div> */}
                                { is_athlete && <Wearables /> }
                                <MainMenu />
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </header>
    );
}